import React, { useEffect, useState } from "react";
import axios from "axios";
import { parse } from "tldts";
import "../css/Support.css";
import Navbarlanding from "../landing/Navbarlanding";
import Footerlanding from "../landing/Footerlanding";

const Support = () => {
  const [company, setCompany] = useState({
    name: "Our Company",
    logo: "",
    favicon: "",
    domain: "",
    subdomain: "",
    email:"",
    contact:"",
  });
  const [fetchError, setFetchError] = useState("");

  const getDomainInfo = () => {
    const hostname = window.location.hostname;
    const parsed = parse(hostname);
    return {
      domain: parsed.domainWithoutSuffix || "",
      subdomain: parsed.subdomain || "",
    };
  };

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const { domain } = getDomainInfo();
        const response = await axios.get("https://payyug.in/api/get-company", {
          params: { domain },
        });
        const data = response.data;

        if (data && Object.keys(data).length > 0) {
          setCompany((prev) => ({
            ...prev,
            name: data.name || prev.name,
            logo: data.logo || prev.logo,
            favicon: data.favicon || prev.favicon,
            domain: data.domain || prev.domain,
            subdomain: data.subdomain || prev.subdomain,
            email: data.email || prev.email,
            contact: data.contact || prev.contact,
          }));

          if (data.favicon) {
            const link =
              document.querySelector("link[rel*='icon']") ||
              document.createElement("link");
            link.type = "image/png";
            link.rel = "icon";
            link.href = `https://payyug.in/${
              data.favicon.startsWith("images/")
                ? data.favicon.slice(7)
                : data.favicon
            }`;
            document.head.appendChild(link);
          }
        } else {
          setFetchError("Company info not found.");
        }
      } catch (err) {
        console.error("Company fetch failed:", err);
        setFetchError("Failed to fetch company info.");
      }
    };

    fetchCompany();
  }, []);

//   const supportEmail = company.domain
//     ? `support@${company.domain}.in`
//     : "support@yourdomain.com";
//   const supportEmail=company?`${company.email}`:"support@yourdomain.com";

//   const contactEmail = company.domain
//     ? `contact@${company.domain}.in`
//     : "contact@yourdomain.com";

const supportEmail = company?.email || "support@yourdomain.com";
const contactEmail = company?.email || "contact@yourdomain.com";
console.log(supportEmail,contactEmail)
console.log(company);
useEffect (() => {
    console.log(company?.email);
},[company])

  return (
    <div className="support-page">
      <Navbarlanding />

      <div className="support-wrapper">
        <h1>Support & Contact Us</h1>

        {fetchError && <p className="error-text">{fetchError}</p>}

        <section>
          <h2>Customer Support</h2>
          <p>
            At {company.name}, customer satisfaction is our top priority. We are
            committed to providing reliable, timely, and transparent support to
            help you with all banking software–related services, account queries,
            and loan applications.
          </p>
          <p>
            If you face any issue or require information regarding our services,
            our support team is always ready to assist you.
          </p>
        </section>

        <section>
          <h2>How We Can Help You</h2>
          <p>You can contact {company?.name} support for assistance related to:</p>
          <ul>
            <li>Account registration and login issues</li>
            <li>Savings, RD, FD, and Virtual Account queries</li>
            <li>Loan application status (Group, Personal, Instant, Small Business Loan)</li>
            <li>KYC verification and document submission</li>
            <li>Transaction-related issues</li>
            <li>Technical or system-related support</li>
            <li>General service-related inquiries</li>
          </ul>
        </section>

        <section>
          <h2>Email Support</h2>

          <div className="email-box">
            <h3>Customer Support (Technical & Service Assistance)</h3>
            <p>📧 {supportEmail}</p>
            <p>📞{company.contact}</p>
            <ul>
              <li>Account and transaction issues</li>
              <li>Login or access problems</li>
              <li>Loan or service-related support</li>
              <li>KYC and documentation assistance</li>
            </ul>
          </div>


          <div className="email-box">
            <h3>Official & Business Communication</h3>
            <p>📧 {contactEmail}</p>
            <p>📞{company.contact}</p>
            <ul>
              <li>General information</li>
              <li>Business inquiries</li>
              <li>Partnership or corporate communication</li>
              <li>Official correspondence</li>
            </ul>
          </div>
        </section>

        <section>
          <h2>Support Availability</h2>
          <p><strong>🕘 Working Hours:</strong></p>
          <p>Monday to Saturday: 9:00 AM – 6:00 PM</p>
          <p>Sunday & Government Holidays: Closed</p>
          <p>
            We aim to respond to all genuine support requests within a reasonable
            timeframe during working hours.
          </p>
        </section>

        <section>
          <h2>Data Privacy & Security Support</h2>
          <p>For any concerns related to:</p>
          <ul>
            <li>Data privacy</li>
            <li>Information security</li>
            <li>KYC data correction</li>
            <li>Privacy Policy requests</li>
          </ul>
          <p>Please contact us at: 📧 {supportEmail}</p>
        </section>

        <section className="security-notice">
          <h2>Important Security Notice</h2>
          <p>
            {company.name} never asks for your OTP, PIN, password, or confidential
            details via email, phone, or message.
          </p>
          <p>
            Do not share sensitive information with anyone claiming to represent
            {company.name} without verification.
          </p>
          <p>You are responsible for keeping your login credentials secure.</p>
        </section>

        <section>
          <h2>Our Support Commitment</h2>
          <ul>
            <li>Providing accurate and transparent information</li>
            <li>Resolving customer issues responsibly</li>
            <li>Maintaining confidentiality and data protection</li>
            <li>Ensuring a smooth digital banking experience</li>
          </ul>
        </section>

        <section className="disclaimer">
          <h2>Disclaimer</h2>
          <p>
            {company.name} is a digital banking software platform. Support
            services are provided based on the nature of the request, system
            availability, and applicable rules and policies.
          </p>
        </section>
      </div>

      <Footerlanding />
    </div>
  );
};

export default Support;
